import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
import { useCallback } from 'react';
import { MenuItemContainer } from '../../../components/menuItemContainer';
import { openAdminView } from '../../../redux/actions/commonReduxActions';
import { useAppDispatch } from '../../../redux/store';
export const PlayerOpenAdminViewMenuItem = ({ playerIdName, closeMenu }) => {
    const dispatch = useAppDispatch();
    const onClick = useCallback(() => {
        dispatch(openAdminView(playerIdName.id));
    }, [dispatch, playerIdName.id]);
    return (_jsx(MenuItemContainer, { label: 'Open Admin View', svgIconComponent: LaunchRoundedIcon, onClick: onClick, closeMenu: closeMenu }));
};
